export class ColorConstruct{

    public _r : number = 0
    public _g : number = 0
    public _b : number = 0

    get r(){
        return this._r
    }

    set r(r : number){
        this._r = r
    }

    get g(){
        return this._g
    }

    set g(g : number){
        this._g = g
    }

    get b(){
        return this._b
    }

    set b(b : number){
        this._b = b
    }

    constructor(r : number = 0, g : number = 0, b : number = 0)
    {
        this._r = r;
        this._g = g;
        this._b = b;
    }

    public clone()
    {
        return new ColorConstruct(this.r, this.g, this.b);
    }

    public equals(color)
    {
        return this.r == color.r && this.g == color.g && this.b == color.b;
    }

    get hex(){
        let integer = this.r * 256 * 256 + this.g * 256 + this.b;
        let hex = ('000000'+ integer.toString(16).toUpperCase() ).slice(-6);
        return '#' + hex;
    }

    get int(){
        let integer = this.r * 256 * 256 + this.g * 256 + this.b;
        return integer;
    }

    public static createFromHex(hex : string)
    {
        var hexContent = hex.substr(0, 1) == "#" ? hex.substr(1, 6) : hex; 
        var r = parseInt(hexContent.substr(0, 2), 16);
        var g = parseInt(hexContent.substr(2, 2), 16);
        var b = parseInt(hexContent.substr(4, 2), 16);

        return new ColorConstruct(r, g, b);
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            r : this.r,
            g : this.g,
            b : this.b
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var color = new ColorConstruct();
        // レイヤー共通
        if(jsonData.r) { color.r = jsonData.r; }
        if(jsonData.g) { color.g = jsonData.g; }
        if(jsonData.b) { color.b = jsonData.b; }
        return color;
    }

    /**
     * 16進表記からColorConstructを生成する
     * @param hexColor 16進表記の色指定
     */
    public static fromHexString(hexColor: string): ColorConstruct {
        // TODO 3桁にも対応する
        const re = /^#?([0-9a-f]{6})$/i;
        const result: string[] | null = re.exec(hexColor);
        // TODO エラーちゃんとする
        if (!result) { throw `no hex: ${hexColor}`; }
        const hex: string = result[1];
        const r: number = parseInt(hex.slice(0, 2), 16);
        const g: number = parseInt(hex.slice(2, 4), 16);
        const b: number = parseInt(hex.slice(4, 6), 16);
        return new ColorConstruct(r, g, b);
    }
}
